import { OnboardingService } from '../../../../services/onboarding'
import { updateEvent, getEvents, batches } from './store'
import { updateEventResponse, updateEventsBatchId } from './eventUpdates'

const clearUnresolvedBatches = async (userId, events) => {
  var promises = []
  const storedBatches = [...new Set(events.map(x => x.value.BatchId).filter(x => x !== undefined))]
  const unresolvedBatches = storedBatches.filter(x => !batches.includes(x))
  unresolvedBatches.forEach(batchId => {
    var eventsToUpdate = events.filter(x => x.value.BatchId === batchId)
    eventsToUpdate.forEach(event => {
      event.value.BatchId = undefined
      promises.push(updateEvent(userId, event.key, event.value))
    })
  })
  await Promise.all(promises)
}

export const sendPendingEventsLogic = async (userId) => {
  var response
  const events = await getEvents(userId)
  await clearUnresolvedBatches(userId, events)
  const pendingEvents = events.map(
      (event, originalIndex) => event.value.ResultCode === 0 && event.value.BatchId === undefined ? {event: event.value, originalIndex} : undefined
    ).filter(x => x !== undefined)
  if (!pendingEvents || pendingEvents.length === 0) {
    return true
  }
  // Generate and mark events to be send with a batchId
  await updateEventsBatchId(userId, events, pendingEvents)

  if (pendingEvents && pendingEvents.length > 1) {
    response = await OnboardingService.postStepEventBatch(pendingEvents.map(x => x.event))
  } else {
    response = await OnboardingService.postStepEvent(pendingEvents[0].event.StepId, pendingEvents[0].event.EventId, pendingEvents[0].event.EventValue)
  }

  return await updateEventResponse(userId, events, pendingEvents, response)
}
